import m from "./../../../dist/es2015/locales/tr_TR.js";
export const am5locales_tr_TR = m;